module.exports = __webpack_public_path__ + "static/media/blueWig.ed3b3b26.png";